const productFlags = {
    None: 0,
    NoRemoveItems: 1 // Ingredients for now
}

export default productFlags